import * as THREE from 'three';

THREE.Vector2.InstanceScalarSize = 2;
THREE.Vector3.InstanceScalarSize = 3;
THREE.Vector4.InstanceScalarSize = 4;

THREE.Color.InstanceScalarSize = 3;
THREE.Quaternion.InstanceScalarSize = 4;

THREE.Matrix3.InstanceScalarSize = 9;
THREE.Matrix4.InstanceScalarSize = 16;




// WEBPACK FOOTER //
// ./src/polyMesh/three/ThreeInstanceScalarSize.js